import * as yup from 'yup'
import { I18n } from 'react-redux-i18n'
import { isNil } from 'lodash'
import { isValidPhoneNumber } from 'react-phone-number-input'

const phoneRegExp = /^\+((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

const phoneValidation = (value: any) => {
  const regexp = RegExp(phoneRegExp)
  return !isNil(value) && regexp.test(value) && isValidPhoneNumber(value)
}

const schema = yup.object({
  firstname: yup
    .string()
    .trim()
    .min(1)
    .required(() => I18n.t(`personalInfo.address.errors.default`)),
  lastname: yup
    .string()
    .trim()
    .min(1)
    .required(() => I18n.t(`personalInfo.address.errors.default`)),
  city: yup.string().required(() => I18n.t(`personalInfo.address.errors.default`)),
  address1: yup.string().required(() => I18n.t(`personalInfo.address.errors.default`)),
  address2: yup.string(),
  zipcode: yup.string().required(() => I18n.t(`personalInfo.address.errors.default`)),
  phone: yup
    .string()
    .trim()
    .test('valid-phone', 'Numéro de téléphone invalide', (value: any) => phoneValidation(value))
    .required('Ce champ est obligatoire'),
  countryIso: yup.string().required(() => I18n.t(`personalInfo.address.errors.default`)),
})

export default schema
